"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconNew = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconNew = function SvgIconNew(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94941 2.94941C4.49327 2.40556 5.2309 2.10002 6.00002 2.10002C6.76915 2.10002 7.50678 2.40556 8.05063 2.94941C8.59449 3.49327 8.90002 4.2309 8.90002 5.00002V8.40002H3.10002V5.00002C3.10002 4.2309 3.40556 3.49327 3.94941 2.94941ZM1.90002 8.40002V5.00002C1.90002 3.91264 2.33199 2.86979 3.10089 2.10089C3.86979 1.33199 4.91264 0.900024 6.00002 0.900024C7.08741 0.900024 8.13026 1.33199 8.89916 2.10089C9.66806 2.86979 10.1 3.91264 10.1 5.00002V8.40002H10.5C10.8314 8.40002 11.1 8.66865 11.1 9.00002C11.1 9.3314 10.8314 9.60002 10.5 9.60002H9.50111C9.50075 9.60002 9.50039 9.60003 9.50002 9.60003L8.01249 9.60002C7.91372 9.93126 7.73379 10.2361 7.48495 10.4849C7.09112 10.8788 6.55698 11.1 6.00002 11.1C5.44307 11.1 4.90893 10.8788 4.5151 10.4849C4.26626 10.2361 4.08632 9.93126 3.98756 9.60002L2.50002 9.60003C2.49966 9.60003 2.4993 9.60002 2.49894 9.60002H1.50002C1.16865 9.60002 0.900024 9.3314 0.900024 9.00002C0.900024 8.66865 1.16865 8.40002 1.50002 8.40002H1.90002ZM5.3292 9.60002C5.34031 9.61244 5.35179 9.62458 5.36363 9.63642C5.53241 9.8052 5.76133 9.90002 6.00002 9.90002C6.23872 9.90002 6.46764 9.8052 6.63642 9.63642C6.64826 9.62458 6.65974 9.61244 6.67085 9.60002H5.3292Z",
    fill: "currentColor"
  }));
};

exports.SvgIconNew = SvgIconNew;